export default "__VITE_ASSET__7bfa84ad__"